module.exports = __webpack_public_path__ + "static/media/linkedin.1a81bfff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/linkedin.svg
// module id = 1791
// module chunks = 0